import Vue from 'vue'

import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  // set observer to true
  observer: true,//false会出现偶尔不刷新的情况

  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
})
